// extracted by mini-css-extract-plugin
export default {"container":"TableList_container__eSPRB","tableContainer":"TableList_tableContainer__yi0iU","imagePlaceholder":"TableList_imagePlaceholder__BYG4v","info":"TableList_info__mLpOS"};